module.exports = __webpack_public_path__ + "static/media/flooring_material_60y_y.a9db82b5.csv";